import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HomeLoanState {
    loanAmount: string;
    interestRate: string;
    loanTerm: string;
    extraPayment: string; // Add extraPayment field
}

const initialState: HomeLoanState = {
    loanAmount: '',
    interestRate: '',
    loanTerm: '30', // Default value for loanTerm is '30'
    extraPayment: '', // Initialize extraPayment as an empty string
};

const homeLoanSlice = createSlice({
    name: 'homeLoan',
    initialState,
    reducers: {
        setHomeLoanData: (state, action: PayloadAction<HomeLoanState>) => {
            state.loanAmount = action.payload.loanAmount;
            state.interestRate = action.payload.interestRate;
            state.loanTerm = action.payload.loanTerm;
            state.extraPayment = action.payload.extraPayment; // Handle extraPayment
        },
        clearHomeLoanData: (state) => {
            state.loanAmount = '';
            state.interestRate = '';
            state.loanTerm = '30'; // Resetting to default loan term
            state.extraPayment = ''; // Reset extraPayment
        },
    },
});

export const { setHomeLoanData, clearHomeLoanData } = homeLoanSlice.actions;

export default homeLoanSlice.reducer;
